

































import {
  Component, Vue, Prop, Watch, Ref,
} from 'vue-property-decorator';
import TimerButton from '@/TimerButton';
import { updatePhone } from 'service/api';
import { ElForm } from 'element-ui/types/form.d';

@Component({
  components: { TimerButton },
})
export default class PhoneInfo extends Vue {
  @Ref('form') readonly form!: ElForm;

  @Prop(String) phone!: string;

  @Watch('phone')
  onValueChange(val: string) {
    this.phoneInfo.phone = val;
  }

  phoneInfo = {
    phone: '',
    code: '',
  };

  phoneRules = {
    phone: [
      {
        required: true,
        pattern: /^1[3456789]\d{9}$/,
        message: '请输入正确的手机号',
        trigger: 'blur',
      },
    ],
    code: [
      {
        required: true, pattern: /^\d{6}$/, message: '验证码为6位数字', trigger: 'blur',
      },
    ],
  };

  submit() {
    this.form.validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        try {
          const res = await updatePhone({
            phonenumber: this.phoneInfo.phone,
            singleSendercode: this.phoneInfo.code,
            codeType: 3,
          }) as { state: boolean; message: string };
          if (res.state) {
            this.$message.success('修改成功！');
            this.$emit('change');
          } else {
            this.$notify.error(res.message);
          }
        } finally {
          this.loading = false;
        }
      }
    });
  }

  loading = false;

  mounted() {
    this.phoneInfo.phone = this.phone;
  }
}
